
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's03c75db6e18f29d2': `connexion`,
's03f42eea72154959': `Nom d'utilisateur`,
's053eb89714fe5c46': `Puissance`,
's05e136e67bf479ad': `mètres`,
's091d5d07b5b33dcf': `OK`,
's09b7ae18afb52426': `Profil lumineux`,
's0a95ea7c8e330485': `Latitude`,
's0b43e6e909895c89': `Horizontal`,
's0bd108911963a54f': `Froide`,
's0d249b4af3381730': `Veuillez vous connecter`,
's0eeef467da6b181a': `L'emplacement est déterminant pour la configuration. Chaque site présente des caractéristiques
					spécifiques.
				`,
's0fbf6dc6a1966408': `Suivant`,
's101f0e6c075f0306': `Conseils personnalisés`,
's125083191daf6f61': `Faible`,
's15a852e9f9a50fa5': `Juin`,
's15b92ca12f290f37': `24h Profil de gradation`,
's1667f96d19635ec7': `Zone`,
's18f78df8a253a3bd': `Modifier cette configuration`,
's1c9fc46adbc800fc': `Nous n'avons pas trouvé le lieu.`,
's1da50951bdd7a204': `Canal`,
's2122b8c621efd5fe': `Texte d'appel d'offres`,
's2138d5192571b731': `nouveau`,
's25858219b90108cb': `LDT`,
's2652c22671dc46da': `Copiez cette configuration`,
's26f5f8b809fd7fe5': `Télécharger l'image du produit (png)`,
's28e1da9966f65d52': `Hauteurs de points lumineux disponibles`,
's2ceb11be2290bb1b': `Annuler`,
's2deee7c162e1558b': `déconnexion`,
's2ee707397f19f23d': `toute l'année profil (max)`,
's2fba71bd651bdbfb': `Vertical`,
's30c5118924e9ccf7': `Instructions de montage`,
's36a54400db774fd6': `Emplacement hors de portée`,
's37d9fb643943321e': `Continuer sans luminaire`,
's38bc43eb653b6341': `Veuillez sélectionner`,
's38cb83ea5c1270b3': `Distribution lumineuse`,
's3f6c9690de6c453d': `Non ombragé, orientation de la tête du luminaire vers le sud. Jour de référence: été 21.12., hiver 21.6., printemps/automne: 21.9.`,
's3fda2cc80886276c': `mètre`,
's4394ed0a03867f18': `Hauteur du point lumineux`,
's43fb34257e831c1f': `Non ombragé, orientation de la tête du luminaire vers le nord. Jour de référence: hiver 21.12., été 21.6., printemps/automne: 21.9.`,
's464ff0695f87139f': `Pour ce lieu, veuillez nous contacter afin que nous puissions vous fournir un profil de lumière
					circulaire personnel.
				`,
's47ebf3a8fb3b10c1': `Orientation`,
's48344928cb4a4f8d': `Choisir la localisation du projet`,
's48e186fb300e5464': `Heure`,
's5048efbcb03a6a20': `Données Techniques`,
's5052d10b539eabf0': `Mars`,
's5390f55090d59178': `Aeto s'adapte de manière flexible aux exigences de l'environnement et du projet. Grâce à notre
					configurateur, déterminez les puissances lumineuses possibles en fonction de la taille de l'unité
					solaire à l'aide des données statistiques sur l'ensoleillement et la météo des dix dernières années
					au moins.
				`,
's542a2430b5e7bf68': `Le rayonnement solaire est calculé sans ombrage et avec une orientation au nord.`,
's57eb78864b88cc0e': `Luminaire solaire mince conçu pour s'adapter avec souplesse à l'environnement et aux exigences
					du projet.
				`,
's59b52ef0a2362cf4': `Profil d'éclairage`,
's5dd028a12ddb124b': `Votre profil lumineux`,
's5e175dc39575c652': `on/off`,
's5e399df62bea2918': `Chaude`,
's61053f0e3ebbd272': `Normale`,
's63cc891eb48fbf58': `Votre luminaire`,
's66c5b77248cfa1af': `Luminaire Data`,
's67e5c254c4d8832d': `Contactez-nous pour plus d'informations`,
's6b61044deda3df65': `L'action souhaitée n'est pas possible avec vos décisions précédentes. Voulez-vous désactiver ces
					choix pour continuer?
				`,
's6ec56fb545de4b76': `N'hésitez pas à prendre contact avec nous pour échanger et pour de plus amples informations.
				`,
's7360eecc9b38343d': `Elevée`,
's7574e7a84b0fb574': `Été`,
's794a2ed0326f8bd3': `Distribution lumineuse`,
's7965f9dc5548469e': `Votre zone:`,
's79a9ea7671b44bdc': `Configurez pour votre projet la nouvelle luminaire solaire efficace Aeto.`,
's7ebe6e1acc5d757a': `Etroite`,
's80629ca60d4d77eb': `Découvrir le profil d'éclairage en détail`,
's863b04cd4fb72226': `Capacité de la batterie`,
's874b4e33320ea9fa': `LDT`,
's8750ed2a956654c9': `Résumé`,
's87d32bdbee7f327f': `Votre profil de lumière:`,
's89e9be1960f4c21c': `rouge`,
's8a957ce1c55ba8f0': `Connecté:`,
's8d5cb019f3cae535': `PDF`,
's8d802fff3bde98c3': `Démarrer une nouvelle configuration`,
's904478720bf69a20': `Copy Tendertext to Clipboard`,
's923a14357bb70193': `Automne`,
's9822e5e8ef283182': `Intensité lumineuse`,
's9844ab19fa9b214f': `Sep`,
's9a6e47771188568d': `Ombrage`,
's9ae3ff84f2b87d2b': `Télécharger PDF`,
's9bf7d6fdcd9de5ce': `C'est de cette réflexion qu'est née l'idée d'adapter la lumière artificielle aux rythmes
					naturels : un peu différente chaque jour, à chaque saison et dans chaque endroit du monde, mais
					toujours unique.
				`,
's9d8b8aa2b404c2c8': `Paramètres`,
's9eba0933010df96e': `Plus d'informations`,
's9f0c705e2fd7e391': `Commencez la configuration`,
'sa1070ff7d8c004c4': `Heure de la journée`,
'sa25de1d82d6a4d4e': `Longitude`,
'sa9f14ae61a187f50': `Température de couleur`,
'sab08f8abe884ba64': `Unité solaire`,
'sab7cf21360ead74e': `Hauteur du point lumineux (sur le mât de base)`,
'sab87e31f40553ff2': `Choisissez un luminaire`,
'sac8252732f2edb19': `Date`,
'sbb99f4f1499715c1': `Nous attendons avec impatience l'avenir de la lumière.`,
'sc0bd6202ba1e9149': `Profil lumineux circulaire`,
'sc1966aa0d7e2d0fe': `Notre recommandation de luminaires`,
'sc1a1ae295cc1f0c3': `Calcul des données photovoltaïques. Veuillez patienter...`,
'sc76a095e1ffa22b6': `Moyenne`,
'sc956f29d2ff0ef07': `Emplacement non trouvé`,
'sca51b3d6b0d00e47': `Luminaires disponibles`,
'sca91d01075c0ce84': `Lever du soleil`,
'scb320e45978d3390': `Fabricant`,
'scc75879e9b6998da': `Flux`,
'scd5bf30253fea7aa': `Large`,
'sce2d17cf5d18dee3': `Formulaire de contact`,
'sd35032a7b73b36ac': `Hiver`,
'sd5d820e378ce757e': `Instructions de montage`,
'sd697d9c07465ce87': `Coucher du soleil`,
'sda2fac80819ad60a': `Activité des insectes`,
'sdac1a66caafe39b2': `Réinitialiser la configuration`,
'sdcb27818fed9da90': `pour`,
'sde96c07df45da349': `Famille`,
'se9d2aaa5182ec3fc': `Rendement énergétique`,
'sec2557a35b702525': `Variable`,
'see2fcaedf9743ec6': `Localisation`,
'seed76e8afe9f604a': `Prix`,
'sefcf950b3cc4fc3b': `Langue`,
'sf6e1665c7022a1f8': `Mot de passe`,
'sfd1e1dc1bf9acb1b': `Depuis plus de 75 ans, nous nous intéressons à la manière d'éclairer les lieux. La question la
					plus importante pour nous est de savoir à quoi l'éclairage devrait ressembler dans les décennies à
					venir. Comment la lumière doit-elle contribuer à la sécurité, à l'orientation et à la beauté ?
					Comment pouvons-nous éviter que nos limites écologiques ne soient davantage mises à l'épreuve ?
					Existe-t-il une lumière parfaite ? La nature nous fournit les réponses.
				`,
'sf4a50a3b63226dd4': `load configuration number`,
's0ed0176ae4af6fd2': `Annual chart`,
's79aea3f15705d95d': `Nature-Centric Lighting`,
'sfe6c68330a2bd563': `Light in natural rhythm for people, plants and animals`,
's28414724644bccc4': `Example days`,
'sfcb319624c989982': `Selected luminaire`,
's15299b8255389e31': `Product Model`,
'sf922f9970316c369': `Pedestrian Activity`,
'sc8c2558dda210387': `Shading Level`,
's3c04f27ce20ea918': `Total Height`,
's84e4ad9f3933d98d': `To access extended configuration options, please`,
'sc141922a5906fd93': `request login`,
    };
  